
const login = data => {
	return new Promise((resolve, reject) => {
		axios.post('/api/auth/login', data, { withCredentials: true }).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

const resetPassword = data => {
	return new Promise((resolve, reject) => {
		axios.post('/api/auth/reset-password', data).then(res => resolve(res.data),).catch(res => reject(res.response))
	})
}

const verifyEmail = access_token => {
	return new Promise((resolve, reject) => {
		axios.post('/api/auth/verify-email', {}, { headers: { Authorization: 'Bearer ' + access_token } }).then(res => resolve(res.data),).catch(res => reject(res.response))
	})
}

const tokenLogin = token => {
	return new Promise((resolve, reject) => {
		axios.post('/api/auth/token-login', { token }, { withCredentials: true }).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

const logout = access_token => {
	return new Promise((resolve, reject) => {
		axios.get('/api/auth/logout', { headers: { Authorization: 'Bearer ' + access_token } }).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

const changePassword = (data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/auth/change-password', data, { headers: { Authorization: 'Bearer ' + access_token } }).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

const register = data => {
	return new Promise((resolve, reject) => {
		axios.post('/api/auth/register', data).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

const update = (id, data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/user/' + id, data, { headers: { Authorization: 'Bearer ' + access_token } }).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

const dashboard = (id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/user/view/' + id, { headers: { Authorization: 'Bearer ' + access_token } }).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

const affiliates = (id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/user/affiliates/' + id, { headers: { Authorization: 'Bearer ' + access_token } }).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

const usePromo = (key, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/user/use-promo/' + key, {
			params: {
				user_str_id: user_str_id ? user_str_id : null
			}
		}).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

const userFavorites = (user_str_id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/user/favorites', {
			params: {
				user_str_id: user_str_id ? user_str_id : null,
				access_token: access_token ? access_token : null
			}
		}).then(res => resolve(res.data)).catch(res => reject(res.response))
	})
}

export {
	login,
	resetPassword,
	tokenLogin,
	logout,
	changePassword,
	register,
	update,
	dashboard,
	affiliates,
	usePromo,
	userFavorites,
	verifyEmail
}